var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"the-link",attrs:{"target":"_blank","href":_vm.link,"rel":"noreferrer"}},[_vm._v(_vm._s(_vm.$t("components.whatsNewLink.text")))])}
var staticRenderFns = []

export { render, staticRenderFns }